// Production configuration
export const API_BASE_URL = 'https://choice-backend-378715339245.us-central1.run.app';

export const API_ENDPOINTS = {
  // Auth endpoints
  login: `${API_BASE_URL}/api/auth/login`,
  register: `${API_BASE_URL}/api/auth/register`,
  profile: `${API_BASE_URL}/api/auth/profile`,
  verify: `${API_BASE_URL}/api/auth/verify`,
  
  // Aggregator endpoints
  aggregator: {
    stats: `${API_BASE_URL}/api/aggregator/stats`,
    referrals: `${API_BASE_URL}/api/aggregator/referrals`,
    commissions: `${API_BASE_URL}/api/aggregator/commissions`,
    tier: `${API_BASE_URL}/api/aggregator/tier`,
    withdraw: `${API_BASE_URL}/api/aggregator/withdraw`
  },
  
  // Content Management endpoints
  content: {
    pending: `${API_BASE_URL}/api/content/pending`,
    approve: `${API_BASE_URL}/api/content/approve`,
    reject: `${API_BASE_URL}/api/content/reject`,
    all: `${API_BASE_URL}/api/content/all`
  },
  
  // Channel endpoints
  channels: {
    list: `${API_BASE_URL}/api/channels`,
    create: `${API_BASE_URL}/api/channels/create`,
    update: `${API_BASE_URL}/api/channels/update`,
    delete: `${API_BASE_URL}/api/channels/delete`,
    stats: `${API_BASE_URL}/api/channels/stats`
  },
  
  // Investment endpoints
  investments: {
    opportunities: `${API_BASE_URL}/api/investments/opportunities`,
    portfolio: `${API_BASE_URL}/api/investments/portfolio`,
    invest: `${API_BASE_URL}/api/investments/invest`,
    withdraw: `${API_BASE_URL}/api/investments/withdraw`
  },
  
  // Finance endpoints
  finance: {
    payments: `${API_BASE_URL}/api/finance/payments`,
    revenue: `${API_BASE_URL}/api/finance/revenue`,
    transactions: `${API_BASE_URL}/api/finance/transactions`,
    approve: `${API_BASE_URL}/api/finance/approve`
  },
  
  // Analytics endpoints
  analytics: {
    overview: `${API_BASE_URL}/api/analytics/overview`,
    channels: `${API_BASE_URL}/api/analytics/channels`,
    creators: `${API_BASE_URL}/api/analytics/creators`,
    revenue: `${API_BASE_URL}/api/analytics/revenue`
  },
  
  // User Management endpoints
  users: {
    list: `${API_BASE_URL}/api/users`,
    create: `${API_BASE_URL}/api/users/create`,
    update: `${API_BASE_URL}/api/users/update`,
    delete: `${API_BASE_URL}/api/users/delete`,
    roles: `${API_BASE_URL}/api/users/roles`
  },
  
  // Support endpoints
  support: {
    tickets: `${API_BASE_URL}/api/support/tickets`,
    create: `${API_BASE_URL}/api/support/create`,
    reply: `${API_BASE_URL}/api/support/reply`,
    close: `${API_BASE_URL}/api/support/close`
  }
};

console.log('Backend URL configured as:', API_BASE_URL);